import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "sidebar-children"
}
const _hoisted_4 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = ["src"]

import { useI18n } from 'vue-i18n';
    import { ref, watch } from 'vue';
    import { useStore } from 'vuex';
    import { useRoute } from 'vue-router';
    import type { PropType } from 'vue';
    import { Colors } from '@/public/styles/utils/variables';

    export interface SidebarItem {
        type?: 'header' | 'item';
        title: string;
        value: string;
        path?: string;
        name?: string;
        prependIcon?: string;
        img?: string;
        hasChildren?: boolean;
        isClientSite?: boolean;
        hidden?: boolean;
        superAdmin?: boolean;
        subItems?: SidebarItem[];
        badge?: string;
        allowedRoles?: string[];
        isDivider?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarItem',
  props: {
        item: {
            type: Object as PropType<SidebarItem>,
            required: true,
        },
        isRailed: {
            type: Boolean,
        },
    },
  emits: ["item-click"],
  setup(__props, { emit: __emit }) {

    const { t } = useI18n();

    /**
     * Sidebar icons have historically been bare filenames living in the shell's own
     * `@/assets/images/sidebar_icons/`. A submodule (e.g. `src/crm`) keeps its icons in its own
     * `src/assets/` and imports them in its route file, so `img` arrives here already resolved by
     * webpack — either a URL or an inlined `data:` URI. Pass those straight through; keep requiring
     * bare filenames from the shell folder so every existing nav item is unaffected.
     */
    const resolveImg = (img: string): string =>
        img.includes('/') || img.startsWith('data:')
            ? img
            : require(`@/assets/images/sidebar_icons/${img}`);
    const route = useRoute();
    const store = useStore();

    const isVisible = (candidate: SidebarItem): boolean =>
        !candidate.hidden && (!candidate.superAdmin || store.getters.superAdmin === true);

    const props = __props;

    const emit = __emit;

    // Simple reactive state for this item's expansion
    const isExpanded = ref(false);

    // Watch for route changes to auto-expand items based on the current route
    watch(
        () => route?.path || '',
        (currentPath) => {
            if (!currentPath) return;

            // Check if this route or any child routes are active
            const shouldExpand = props.item.path && currentPath.startsWith(props.item.path);

            // Check subitems if not a direct match
            if (!shouldExpand && props.item.subItems) {
                const hasActiveChild = props.item.subItems.some(
                    (subItem) => subItem.path && currentPath.startsWith(subItem.path),
                );
                isExpanded.value = hasActiveChild;
            } else {
                isExpanded.value = Boolean(shouldExpand);
            }
        },
        { immediate: true },
    );

    const handleClick = () => {
        emit('item-click');
    };

    const toggleExpanded = () => {
        isExpanded.value = !isExpanded.value;
    };

    const handleSubItemClick = () => {
        emit('item-click');
    };

return (_ctx: any,_cache: any) => {
  const _component_AQIcon = _resolveComponent("AQIcon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_SidebarItem = _resolveComponent("SidebarItem", true)!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (__props.item.isClientSite)
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.item.subItems, (subItem, idx) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: subItem.value || idx
        }, [
          (isVisible(subItem))
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                title: props.isRailed ? undefined : _unref(t)(subItem.title),
                value: subItem.value,
                to: { name: subItem.name, params: _unref(route)?.params || {} },
                onClick: handleClick
              }, _createSlots({
                prepend: _withCtx(() => [
                  (subItem.prependIcon)
                    ? (_openBlock(), _createBlock(_component_AQIcon, {
                        key: 0,
                        name: subItem.prependIcon,
                        color: _unref(Colors).aquassistWhite
                      }, null, 8, ["name", "color"]))
                    : _createCommentVNode("", true),
                  (subItem.img)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        width: "20px",
                        height: "20px",
                        class: "filter--white mr-4",
                        src: resolveImg(subItem.img),
                        alt: ""
                      }, null, 8, _hoisted_1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, [
                (subItem.badge)
                  ? {
                      name: "append",
                      fn: _withCtx(() => [
                        (_unref(store).getters[`siteOrders/${subItem.badge}`] > 0)
                          ? (_openBlock(), _createBlock(_component_v_badge, {
                              key: 0,
                              content: _unref(store).getters[`siteOrders/${subItem.badge}`],
                              color: "aquassistRed",
                              inline: ""
                            }, null, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["title", "value", "to"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (__props.item.hasChildren || (__props.item.subItems && __props.item.subItems.length))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_list_item, {
                title: _unref(t)(__props.item.title),
                to: { name: __props.item.name, params: _unref(route)?.params || {} },
                onClick: toggleExpanded,
                class: "sidebar-parent-item"
              }, {
                prepend: _withCtx(() => [
                  (__props.item.prependIcon)
                    ? (_openBlock(), _createBlock(_component_AQIcon, {
                        key: 0,
                        name: __props.item.prependIcon,
                        color: _unref(Colors).aquassistWhite,
                        size: "small"
                      }, null, 8, ["name", "color"]))
                    : _createCommentVNode("", true),
                  (__props.item.img)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        width: "20px",
                        height: "20px",
                        class: "filter--white mr-4",
                        src: resolveImg(__props.item.img),
                        alt: ""
                      }, null, 8, _hoisted_2))
                    : _createCommentVNode("", true)
                ]),
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: isExpanded.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                    color: "white",
                    size: "small"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["title", "to"]),
              _createVNode(_component_v_expand_transition, null, {
                default: _withCtx(() => [
                  (isExpanded.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.subItems, (subItem, idx) => {
                          return (_openBlock(), _createBlock(_component_SidebarItem, {
                            key: subItem.value || idx,
                            item: subItem,
                            "is-railed": props.isRailed,
                            onItemClick: handleSubItemClick
                          }, null, 8, ["item", "is-railed"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 64))
          : (__props.item.type === 'header')
            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panels, { variant: "accordion" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, null, {
                            default: _withCtx(() => [
                              (__props.item.prependIcon)
                                ? (_openBlock(), _createBlock(_component_AQIcon, {
                                    key: 0,
                                    name: __props.item.prependIcon,
                                    color: _unref(Colors).aquassistWhite
                                  }, null, 8, ["name", "color"]))
                                : _createCommentVNode("", true),
                              (!props.isRailed)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)(__props.item.title)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_fade_transition, { "leave-absolute": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.subItems, (subItem, idx) => {
                                        return (_openBlock(), _createBlock(_component_SidebarItem, {
                                          key: subItem.value || idx,
                                          item: subItem,
                                          "is-railed": props.isRailed,
                                          onItemClick: handleSubItemClick
                                        }, null, 8, ["item", "is-railed"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (__props.item.isDivider)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)(__props.item.title)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider, { class: "customDivider" })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (isVisible(__props.item))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: __props.item.value,
                        title: props.isRailed ? undefined : _unref(t)(__props.item.title),
                        value: __props.item.value,
                        to: { name: __props.item.name, params: _unref(route)?.params || {} },
                        onClick: handleClick
                      }, {
                        prepend: _withCtx(() => [
                          (__props.item.prependIcon)
                            ? (_openBlock(), _createBlock(_component_AQIcon, {
                                key: 0,
                                name: __props.item.prependIcon,
                                color: _unref(Colors).aquassistWhite
                              }, null, 8, ["name", "color"]))
                            : _createCommentVNode("", true),
                          (__props.item.img)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                width: "20px",
                                height: "20px",
                                class: "filter--white mr-4",
                                src: resolveImg(__props.item.img),
                                alt: ""
                              }, null, 8, _hoisted_6))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["title", "value", "to"]))
                    : _createCommentVNode("", true)
                ], 64))
      ], 64))
}
}

})